export default "__VITE_ASSET__DxV$q$_t__"